// extracted by mini-css-extract-plugin
export default {"paragraph":"Paragraph_paragraph__0X1FW","xl":"Paragraph_xl__qJbEn","l":"Paragraph_l__TrGIv","m":"Paragraph_m__PdAl8","s":"Paragraph_s__EGG8D","xs":"Paragraph_xs__YWDY5"};